
// client/src/context/MessagesContext.jsx
import React, { createContext, useContext, useState, useCallback } from 'react';

const MessagesContext = createContext(undefined);

export function MessagesProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [activeThreadId, setActiveThreadId] = useState(null);

  const openMessages = useCallback((threadId = null) => {
    setActiveThreadId(threadId);
    setIsOpen(true);
  }, []);

  const closeMessages = useCallback(() => {
    setIsOpen(false);
    setActiveThreadId(null);
  }, []);

  const value = {
    isOpen,
    activeThreadId,
    openMessages,
    closeMessages
  };

  return (
    <MessagesContext.Provider value={value}>
      {children}
    </MessagesContext.Provider>
  );
}

export function useMessagesUI() {
  const context = useContext(MessagesContext);
  if (context === undefined) {
    throw new Error('useMessagesUI must be used within <MessagesProvider>');
  }
  return context;
}

export { MessagesContext };
export default MessagesContext;